
<template>
  <div v-if="mailContent.isSystemMessage" class="flex-grow">
    <vs-divider>
      <div class="flex items-center flex-col">
        <b>{{ mailContent.text }}</b>
        <span>{{ mailContent.timestamp | formatTime }}</span>
      </div>
    </vs-divider>
  </div>
  <vx-card v-else class="px-4" style="color: #333">
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div
        class="
          vx-col
          w-full
          border-b border-l-0 border-r-0 border-t-0
          d-theme-border-grey-light
          border-solid
          flex
          justify-between
          flex
          items-center
        "
      >
        <!-- Sender Details -->
        <div class="flex items-center">
          <div>
            <vs-avatar
              class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white"
              :src="senderImg(mailContent.didSend, conversation.venueId)"
              :color="mailContent.didSend ? venue(conversation.venueId).style.colorBackground : ''"
              size="65px"
            />
          </div>

          <div class="flex flex-col">
            <h5 class="mb-1">
              {{ mailContent.fromName }}
            </h5>
            <div class="flex items-center">
              <span class="text-sm">{{ mailContent.fromMail }}</span>
              <vs-dropdown vs-custom-content vs-trigger-click class="inline-flex cursor-pointer">
                <feather-icon icon="ChevronDownIcon" class="w-3 h-3" />
                <vs-dropdown-menu style="z-index: 40001">
                  <div class="p-2">
                    <p class="text-sm mb-1">
                      From:
                      <span class="font-semibold">
                        {{ mailContent.fromMail }}
                      </span>
                    </p>
                    <p class="text-sm mb-1">
                      To:
                      <span class="font-semibold">
                        {{ mailContent.toMail }}
                      </span>
                    </p>
                    <p class="text-sm mb-1">
                      Date:
                      <span class="font-semibold"> {{ mailContent.timestamp | date }}</span>
                    </p>
                    <!---<p class="text-sm mb-1" v-if="mailContent.cc.length">cc: <span class="font-semibold"> {{ mailContent.cc | csv }} </span></p>-->
                  </div>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
        <div class="flex flex-col justify-end">
          <span class="text-right">{{ mailContent.timestamp | formatTime }}</span>
          <div class="flex justify-end mt-2">
            <span class="text-right">{{ mailContent.timestamp | date }}</span>
          </div>
        </div>
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <!-- MAIL CONTENT -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div
          :class="{
            'whitespace-pre-wrap': !mailContent.isHtml,
          }"
          class="mail__content break-words mt-8 mb-4"
          v-text="mailContent.text"
          v-if="!mailContent.isHtml"
        ></div>
        <iframe
          v-else
          ref="mailFrame"
          :srcdoc="mailContent.html"
          scrolling="no"
          onload='javascript:(function(o){
            o.style.height=o.contentWindow.document.body.scrollHeight+40+"px";
            o.contentWindow.document.body.style.fontFamily="Montserrat, Helvetica, Arial, sans-serif";
          }(this));'
          style="width: 100%; border: none; overflow: scroll; display: block"
        ></iframe>
        <!-- <div class="mail__content break-words mt-8 mb-4 whitespace-pre-wrap" v-html="mailContent.html"></div> -->
      </div>
    </div>

    <!-- MAIL ATTACHMENTS -->
    <div class="vx-row" v-if="mailContent.attachments && mailContent.attachments.length">
      <div
        class="
          vx-col
          w-full
          border-b border-l-0 border-r-0 border-t-0
          d-theme-border-grey-light
          border-solid
          mb-6
          flex
        "
      >
        <feather-icon icon="PaperclipIcon" class="mr-2" />
        <span class="block py-4">ATTACHMENTS</span>
      </div>
      <div class="flex">
        <div
          class="mail__attachment"
          v-for="(attachment, index) in mailContent.attachments"
          :key="index"
          @click.stop="downloadAttachment(attachment)"
        >
          <vs-chip color="primary" class="px-4 py-2 mr-3 cursor-pointer">{{ attachment }}</vs-chip>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import mimetype from "mimetype";

export default {
  props: {
    mailContent: {
      type: Object,
      required: true,
    },
    conversation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    venue() {
      return venueId => this.$store.getters["venues/venue"](venueId);
    },
    venueLogo() {
      return venueId => this.$store.getters["venues/venueLogo"](venueId);
    },
    senderImg() {
      return (didSendByActiveUser, venueId) => {
        if (didSendByActiveUser) return this.venueLogo(venueId);
        else return require("@/assets/images/profile-image.png");
      };
    },
  },
  methods: {
    async downloadAttachment(fileName) {
      this.$vs.loading("Retrieving file");
      var dto = {
        venueMail: this.conversation.venueEmail,
        messageId: this.mailContent.messageId,
        fileName: fileName,
        mimeType: mimetype.lookup(fileName),
      };
      await this.$store.dispatch("email/downloadFileAttachment", dto);
      this.$vs.loading.close();
    },
  },
  mounted() {},
};
</script>
